import { useState } from "react";
import { WidgetProps } from "@/types/types";
import { Hero } from "@/components/Hero/Index";
import { TitleSection } from "@/ui/Title/Index";
import SectionWrap from "@/components/SectionWrap/Index";

export const HeroSlider = ({
  data,
  isMobile,
  template,
  colorTheme,
  customText,
}: WidgetProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const postsLength = data.posts.length;
  const widgetColor = data.widgetColor || colorTheme;
  const withEmptySpace = data?.code?.includes("with-space");
  const titleFromPostType = data?.code?.includes("title-postype");
  const maxResolution = data?.code?.includes("res-max");

  const handleNext = () =>
    setCurrentIndex((prev) => (prev === postsLength - 1 ? 0 : prev + 1));

  const handlePrevious = () =>
    setCurrentIndex((prev) => (prev === 0 ? postsLength - 1 : prev - 1));

  const currentPost =
    postsLength > 1 ? data.posts[currentIndex] : data.mainPost;

  const sharedProps = {
    className: "flex-1",
    setActive: setCurrentIndex,
    currentIndex,
    template,
    colorTheme: widgetColor,
    resolution: maxResolution ? 5 : undefined,
  };

  const renderHero = () => (
    <Hero
      key={currentIndex}
      setCurrentIndex={setCurrentIndex}
      data={currentPost}
      isMobile={isMobile}
      handleNext={postsLength > 1 ? handlePrevious : undefined}
      handlePrevious={postsLength > 1 ? handleNext : undefined}
      priority={currentIndex === 0 ? true : undefined}
      customText={customText}
      length={postsLength}
      {...sharedProps}
    />
  );

  if (!data || !data.posts) return null;

  const title =
    titleFromPostType && data?.mainPost?.postType === "picture"
      ? "صور"
      : titleFromPostType && data?.mainPost?.postType === "video"
      ? "فيديو"
      : undefined;

  return (
    <>
      {template === "posts" ? (
        <div className="relative mt-8 mb-0">
          {title || data.title ? (
            <TitleSection
              title={title || data?.title}
              moreUrl={data?.moreLink}
              isMobile={isMobile}
            />
          ) : (
            ""
          )}
          {withEmptySpace ? (
            <div className="flex max-md:flex-col">
              <aside
                className="hidden lg:w-[180px] lg:max-w-[180px] lg:block"
                aria-hidden="true"
              />
              {renderHero()}
            </div>
          ) : (
            renderHero()
          )}
        </div>
      ) : titleFromPostType ? (
        <SectionWrap
          className="block"
          innerClassName="block"
          emptyColumn={withEmptySpace}
        >
          <TitleSection
            title={title || data?.title}
            moreUrl={data?.moreLink}
            isMobile={isMobile}
          />
          {renderHero()}
        </SectionWrap>
      ) : (
        renderHero()
      )}
    </>
  );
};
